export default {
  languages(state) {
    return state.languages;
  },

  languagesObj(state) {
    return state.languagesObj;
  },

  onlyLangObj(state) {
    return state.onlyLangObj;
  },
};
